module.exports = __webpack_public_path__ + "static/media/sell_interview_10.c0bfbd84.jpg";